const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class SubscriptionBorrow
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.tokenCode = options["token-code"];
    this.count = options.count;
    this.subscriptionKey = options["subscription-key"];
    this.profileKey = options["profile-key"];
    this.email = options["profile-email"];
    this.timestamp = options.inserted;
    this.productName = options["product-name"];
  };

  set timestamp(date)
  {
    this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get timestamp()
  {
    return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY HH:mm:ss") : null;
  };

};



// WEBPACK FOOTER //
// ./app/js/models/subscription-borrow.js